'use client';

const getLoadingSize = ({
  size
}) => {
  const loadingSizes = {
    xs: "sm",
    sm: "md",
    md: "md",
    lg: "lg"
  };
  return loadingSizes[size];
};
export {
  getLoadingSize
};
